import React from "react";
import Modal from 'react-bootstrap/Modal';
import { Field } from 'redux-form';
import LessonQuestionsList from "../LessonQuestionsList";
import StudentInClassRoom from "../../../School/StudentInClassRooms/";
import { toast } from 'react-toastify';

const ShareLessonModal = ({ props, lessonItemState }) => {
    const { t, lesson, classRooms, user, type } = props;
    const {
        showShare,
        handleClose,
        ClassRoomId,
        onChangeClassRoom,
        ShowToAll,
        HideFromAll,
        studentType,
        setSelectedStudents,
        SelectCustomeQuestions,
        setSelectCustomeQuestions,
        SelectedQuestions,
        setSelect
    } = lessonItemState;

    if (!showShare) return null;

    const shareTitle = type === "Games" ? t("Pages.Games.action.share") : t("Pages.Lessons.action.share");
    const shareQustionsTitle = type === "Games" ? t("Pages.Games.forms.SelectCustomeQuestions") : t("Pages.Lessons.forms.SelectCustomeQuestions");

    if (classRooms && classRooms.classRooms) {
        return (
            <Modal
                centered
                key="ModalShareLesson"
                size="lg"
                show={showShare}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                enforceFocus={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="icon fal fa-mind-share"></i>
                        {shareTitle} : <span className="text-info"> {lesson.Name}</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="widget widget-category">
                        <div className="widget-body">
                            <div className="contact-form mb-0">
                                <div className="w-100 d-flex justify-content-center">
                                    <div className="form-group">
                                        <label className='text-dark font-size-h5'>
                                            {t('Pages.Lessons.forms.ClassRoom.title')}
                                        </label>
                                        <Field
                                            component="select"
                                            title={t('Pages.Lessons.forms.ClassRoom.title')}
                                            placeholder={t('Pages.Lessons.forms.ClassRoom.Placeholder')}
                                            id="ClassRoomId"
                                            name="ClassRoomId"
                                            onChange={(e) => onChangeClassRoom(e.target.value)}
                                            required={true}
                                            className="form-control"
                                        >
                                            <option></option>
                                            {classRooms.classRooms
                                                .filter(p => p.Teacher?.Id === user.user.Id || p.AssistantTeacher?.Id === user.user.Id)
                                                .sort((a, b) => (a.Name > b.Name ? 1 : -1))
                                                .map(item => (
                                                    <option key={`ClassRoom${item.Id}`} value={item.Id}>
                                                        {item.Name}
                                                    </option>
                                                ))}
                                        </Field>
                                    </div>
                                </div>
                                {ClassRoomId ? (
                                    <>
                                        <div className="w-100 d-flex justify-content-center">
                                            <button
                                                onClick={() => ShowToAll(ClassRoomId, lesson.Id)}
                                                className="btn btn-info mx-1"
                                                title={t('Pages.Lessons.forms.ShowToAll')}
                                            >
                                                <i className="icon fal fa-mind-share"></i>
                                                <span className="d-none d-lg-inline-block">
                                                    {t('Pages.Lessons.forms.ShowToAll')} (
                                                    {studentType === "all"
                                                        ? t("Pages.StudentInClassRoomsControl.AllStudents")
                                                        : studentType === "with_assistant"
                                                        ? t("Pages.StudentInClassRoomsControl.NeedAssistant")
                                                        : t("Pages.StudentInClassRoomsControl.StudentsWithoutNeedAssistant")}
                                                    )
                                                </span>
                                            </button>
                                            <button
                                                onClick={() => HideFromAll(ClassRoomId, lesson.Id)}
                                                className="btn btn-dark mx-1"
                                                title={t('Pages.Lessons.forms.HideFromAll')}
                                            >
                                                <i className="icon fal fa-times"></i>
                                                <span className="d-none d-lg-inline-block">
                                                    {t('Pages.Lessons.forms.HideFromAll')} (
                                                    {studentType === "all"
                                                        ? t("Pages.StudentInClassRoomsControl.AllStudents")
                                                        : studentType === "with_assistant"
                                                        ? t("Pages.StudentInClassRoomsControl.NeedAssistant")
                                                        : t("Pages.StudentInClassRoomsControl.StudentsWithoutNeedAssistant")}
                                                    )
                                                </span>
                                            </button>
                                        </div>
                                        <div className="w-100 mt-4">
                                            <div>
                                                <div className="custom-control custom-checkbox mr-sm-4 checkbox-danger">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        onChange={e => setSelectCustomeQuestions(e.target.checked)}
                                                        defaultChecked={SelectCustomeQuestions}
                                                        name={`SelectCustomeQuestions_${lesson.Id}`}
                                                        id={`SelectCustomeQuestions_${lesson.Id}`}
                                                    />
                                                    <label className="custom-control-label" htmlFor={`SelectCustomeQuestions_${lesson.Id}`}>
                                                        {shareQustionsTitle}
                                                    </label>
                                                </div>
                                            </div>
                                            {SelectCustomeQuestions && (
                                                <div className="mt-3">
                                                    <LessonQuestionsList
                                                        SelectedQuestions={SelectedQuestions}
                                                        LessonId={lesson.Id}
                                                        setSelect={setSelect}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </>
                                ) : ""}
                            </div>
                        </div>
                    </div>
                    {ClassRoomId && (
                        <StudentInClassRoom
                            type={type}
                            Lesson={lesson}
                            LessonId={lesson.Id}
                            forShare={true}
                            classRoomId={ClassRoomId}
                            setSelectedStudents={setSelectedStudents}
                        />
                    )}
                </Modal.Body>
            </Modal>
        );
    } else {
        toast.error(t('Error.NotClassSelected.Title'));
        return null;
    }
};

export default ShareLessonModal;
